module.exports = __webpack_public_path__ + "img/icon-pen.8007b895.svg";